module.exports = __webpack_public_path__ + "media/images/regpic2-0ee7436d.png";